import {
  SET_LOGIN_MESSAGE,
  SET_USER_ID,
  SET_USER_LOGIN_STATUS,
  START_LOGIN_LOADING,
  USER_REGISTRATION,
  SET_USER_EMAIL,
} from "./UserTypes";

export const setLoginMessage = (message) => {
  return {
    type: SET_LOGIN_MESSAGE,
    payload: message,
  };
};

export const setUserId = (id) => {
  return {
    type: SET_USER_ID,
    payload: id,
  };
};

export const setUserEmail = (email) => {
  return {
    type: SET_USER_EMAIL,
    payload: email,
  };
};

export const setUserLogInStatus = (status) => {
  return {
    type: SET_USER_LOGIN_STATUS,
    payload: status,
  };
};

export const startLoginLoading = () => {
  return {
    type: START_LOGIN_LOADING,
  };
};

export const registerUser = (name, email, phone, password) => {
  return {
    type: USER_REGISTRATION,
    name: name,
    email: email,
    phone: phone,
    password: password,
  };
};
